<fgb-account-layout titleKey="account.representative.title" titleDefault="My Representative">
  <fgb-account-panel titleKey="account.representative.title" titleDefault="My Representative">
    <fgb-representative></fgb-representative>
  </fgb-account-panel>
</fgb-account-layout>
